// getInitials — extract up to two-letter initials from a person's name.
// Accepts either:
//   getInitials("Ana", "García")  → "AG"
//   getInitials("Ana García")      → "AG"
//   getInitials("Ana")             → "A"
//   getInitials(null)              → "?"
// Used in Avatars, tags, list headers.

export function getInitials(name, lastName) {
  const first = (name || '').trim();
  const last = (lastName || '').trim();

  if (first && last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  }
  if (first) {
    const parts = first.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return parts[0].charAt(0).toUpperCase();
  }
  return '?';
}

export default getInitials;
